import {svgIconWrapper} from '../svg-icon-wrapper';

import PersonSquareRegular from './person-square-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PersonSquareRegular {...validProps} />;
}

SvgComponent.iconName = 'person-square-regular';

export const PersonSquareRegularIcon = svgIconWrapper(SvgComponent);
